// The badge unlock overlay: one card per badge, Continue moves to the next,
// the last Continue removes the overlay and reveals the page beneath.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card"]

  connect() {
    this.index = 0
    this.cardTargets.forEach((card, i) => { card.hidden = i !== 0 })
    this.cardTargets[0]?.querySelector("button")?.focus()
  }

  continue() {
    this.index += 1
    if (this.index >= this.cardTargets.length) {
      this.element.remove()
      return
    }
    this.cardTargets.forEach((card, i) => { card.hidden = i !== this.index })
    this.cardTargets[this.index].querySelector("button")?.focus()
  }
}
